<template>
  <div class="w-full vx-coll-fixed-height">
    <div class="con-tab mt-4" v-if="_prosecution && _contract">
      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractDate") }}</h6>
          <p>{{ _contract.contractDate | convYYYYMMDDToDDMMYYYY }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractNo") }}</h6>
          <p>{{ _contract.contractNo }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractName") }}</h6>
          <p>{{ _contract.contractName }}{{ _contract.restructuring ? '*' : '' }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.customer.dataForm.idCardNumber") }}</h6>
          <p>{{ _prosecution.borrower.idCardNumber }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contactNumber") }}</h6>
          <p> {{ _prosecution.contactNumber }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.project") }}</h6>
          <p>{{ _prosecution.projectName }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.faculty") }}/{{ $t("sections.accounting.dataForm.curriculum") }}</h6>
          <p> {{ _contract.curriculum }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.accounting.dataForm.periods.begin') }} - {{
              $t('sections.accounting.dataForm.periods.end')
            }}</h6>
          <p>{{ _contract.periods }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.loan.paymentDescription") }}</h6>
          <p>{{ _contract.loanTypeName }}</p>
        </div>


        <div class="vx-col w-full sm:w-1/2" v-if="_contract.restructuring">
          <h6>{{ $t("sections.accounting.dataForm.contractNo") }} (ก่อนปรับโครงสร้างหนี้)</h6>
          <p v-if="_contract.restructuringDetail.contracts.length === 0">ไม่พบเลขที่สัญญา</p>
          <span v-for="(contract, index) in _contract.restructuringDetail.contracts" :key="contract.contractId">
            <a @click="transaction({contractId: contract.id, prosecutionId: contract.prosecution.id})"
            class="cursor-pointer">{{ contract.contractNo }}</a>
            <span v-if="index < _contract.restructuringDetail.contracts.length - 1">, </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapState: mapProsecutionFields} = createNamespacedHelpers('Prosecution')

export default {
  name: "ContractInfoTab",
  components: {},
  props: {},
  computed: {
    ...mapProsecutionFields(['prosecution']),
    _prosecution() {
      if (!this.prosecution) return null
      return {
        ...this.prosecution,
        contactNumber: this.prosecution.borrower ? `${this.prosecution.borrower.phone} ${this.prosecution.borrower.mobile}` : '-',
        projectName: this.prosecution.borrower ? this.prosecution.borrower.project.nameTh : '-',
      }
    },
    _contract() {
      if (!this.prosecution) return
      if (!this.prosecution.contract) return
      return {
        ...this.prosecution.contract,
        periods: `${this.prosecution.contract.periodTermStart}/${this.prosecution.contract.periodYearStart} - ${this.prosecution.contract.periodTermEnd}/${this.prosecution.contract.periodYearEnd}`,
        curriculum: this.prosecution.contract.curriculum ? `${this.prosecution.contract.curriculum.faculty.nameTh}/${this.prosecution.contract.curriculum.nameTh}` : '-',
        loanTypeName: this.prosecution.contract.loan ? this.prosecution.contract.loan.loanTypeName : "-",
      }
    },
  },
  methods: {
    transaction({contractId, prosecutionId}) {
      this.$router.push({name: 'prosecution-transaction-detail', params: {contractId, prosecutionId}})
    },
  }
};
</script>

<style scoped>
.vx-coll-fixed-height {
  display: block;
  width: 100%;
  height: 555px;
  overflow: auto;
}
</style>
